import { Inspector } from './Inspector';
import { Interpreter } from './Interpreter';
import { StateMachine } from './StateMachine';
function buildDefaultInspector(name) {
  return new Inspector({
    initialStatus: 'running',
    name
  });
}
export function createMachine(machineDefinition, options = {}) {
  const inspector = options.inspector || buildDefaultInspector(options.name);
  const machine = new StateMachine(machineDefinition, inspector);
  const interpreter = new Interpreter(machine, options.initialContext);
  if (!options.waitToStart) {
    interpreter.start();
  }
  return interpreter;
}